module.exports = __webpack_public_path__ + "static/parade-2022-1-77f7c7610f5613da3aba97b4eab5cd3e.jpg";